import { KnownOrderDtoStatus, OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useState } from 'react';
import { useSwitchSpaceAction } from '../../../../deliveries/details/actions/switch-space/switch-space-action.hook';
import { useMutationSwitchSpace } from '../../order-details.queries';

export interface SwitchSpaceOrderActionProps {
  order: OrderDto;
  onAbort(): void;
}

export function useSwitchSpaceOrderAction(props: SwitchSpaceOrderActionProps) {
  // Add the order to state so that it doesn't change when the props change
  const [orderState] = useState(props.order);

  const mutation = useMutationSwitchSpace(orderState.retailer.id, orderState.id);

  // If the order is in an invalid state, abort the action
  if (orderState.status !== KnownOrderDtoStatus.Delivered && orderState.status !== KnownOrderDtoStatus.Overdue) {
    props.onAbort();
  }

  function onSubmit(
    deliveryContainerID: string,
    options: {
      onSuccess(): void;
      onError(): void;
    }
  ) {
    mutation.mutate(
      {
        hubID: orderState.hub!.id,
        deliveryContainerID
      },
      {
        onSuccess: () => {
          options.onSuccess();
        },
        onError: () => {
          options.onError();
        }
      }
    );
  }

  return useSwitchSpaceAction({
    hubID: orderState.hub!.id,
    onAbort: props.onAbort,
    onSubmit
  });
}
